cb.define([], function () {


    var PM_pmc_postactivitylist_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            // var pPostPrice = viewmodel.get('pPostPrice').getValue();
            // var iPostPieces = viewmodel.get('iPostPieces').getValue();

            var gridModel = viewmodel.getGridModel();
            var unit = cb.rest.AppContext.user.currencyName || "元";

            gridModel.on('afterSetDataSource', () => {
                const rows = gridModel.getRows();
                const actions = gridModel.getCache('actions');
                const actionsStates = [];
                rows.forEach((data, index) => {
                    var pPostPrice = data.pPostPrice;
                    var iPostPieces = data.iPostPieces;
                    if (pPostPrice == 0 && iPostPieces == 0) {
                        gridModel.setCellValue(index, 'consumptionPatterns', '消费满' + data.pPostPrice + unit + '包邮');
                    } else if (pPostPrice !== 0 && iPostPieces == 0) {
                        gridModel.setCellValue(index, 'consumptionPatterns', '消费满' + data.pPostPrice + unit + '包邮');
                    } else if (pPostPrice == 0 && iPostPieces !== 0) {
                        gridModel.setCellValue(index, 'consumptionPatterns', '消费满' + data.iPostPieces + '件包邮');
                    } else if (pPostPrice !== 0 && iPostPieces !== 0) {
                        gridModel.setCellValue(index, 'consumptionPatterns', '消费满' + data.pPostPrice + unit + ' 且满' + data.iPostPieces + '件包邮');
                    }

                    const actionState = {};
                    actions.forEach(action => {
                        if (action.cItemName == "btnDisAble") {

                            if (data.pValid == 0) {
                                actionState[action.cItemName] = {visible: false};
                            } else {
                                actionState[action.cItemName] = {visible: true};
                            }
                        } else if (action.cItemName == "btnEnAble") {
                            if (data.pValid == 0) {
                                actionState[action.cItemName] = {visible: true};
                            } else {
                                actionState[action.cItemName] = {visible: false};
                            }
                        } else {
                            actionState[action.cItemName] = {visible: true};
                        }
                    });
                    actionsStates.push(actionState);
                });
                gridModel.setActionsState(actionsStates);
            });


        }
    };
    try {
        module.exports = PM_pmc_postactivitylist_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_postactivitylist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_postactivitylist_VM.Extend.js